import { type CSSProperties } from 'react';

import { Breakpoint, type SliderConfig } from '@jsmdg/yoshi';

// Ascending — keep in sync with $breakpoints in @jsmdg/yoshi/dist/scss/_vars.scss.
const TIERS = [
    Breakpoint['3XS'],
    Breakpoint['2XS'],
    Breakpoint.XS,
    Breakpoint.SM,
    Breakpoint.MD,
    Breakpoint.LG,
    Breakpoint.XL,
];

// The fallback is one HTML served to every viewport, so slide width has to come from CSS rather
// than an inline percentage. Emits a --slides/--gap pair per tier that LazySlider.module.scss picks
// up in a media query, resolved the way Swiper resolves its own initial breakpoint: the widest
// override at or below the tier, merged over the base config.
const getSlideSizingVars = (config: SliderConfig): CSSProperties => {
    const vars: Record<string, string | number> = {};
    let active = config;

    for (const tier of TIERS) {
        const override = config.breakpoints?.[tier];

        if (override) {
            active = { ...config, ...override };
        }

        vars[`--slides-${tier}`] = Math.max(active.slidesPerView, 1);
        vars[`--gap-${tier}`] = `${active.spaceBetween}px`;
    }

    return vars as CSSProperties;
};

export { getSlideSizingVars };
